<template>
  <div>
    <v-container fluid>
      <v-card class="card">
        <v-toolbar color="primary" dark>
          <v-toolbar-title class="title">{{
            $t("managementModelAndVector")
          }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-title class="title">{{ today }}</v-toolbar-title>
        </v-toolbar>
        <v-flex class="flex">
          <v-row style="margin-top: 2rem">
            <v-col cols="12" justify="end" align="end">
              <v-btn
                class="primary white--text mt-3"
                style="margin-left: 1em"
                @click="Add()"
                >{{ $t("add") }}</v-btn
              >
            </v-col>
          </v-row>
          <v-data-table
            :items-per-page="itemsPerPage"
            :server-items-length="searchTotalTable"
            :options.sync="options"
            :items="dataTable"
            :headers="headers"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.number }}</td>
                <td style="text-align: left;">{{ item.gptModelName ?? "-" }}</td>
                <td style="text-align: left;">{{ item.vectorDBName }}</td>
                <td>
                  <v-btn icon @click="Edit(item)">
                    <img :src="images.edit" alt="Edit mapping" />
                  </v-btn>
                </td>
                <td>
                  <v-btn icon @click="DeleteVectorDBNameMappinghGPTModel(item.gptModelName,item.vectorDBName)">
                    <img :src="images.delete" alt="Delete mapping" />
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <br />
        <br />
        <br />
      </v-card>
    </v-container>

    <!-- Add GPTModel -->
    <v-dialog v-model="Adddialog" persistent max-width="1000px">
      <v-card>
        <v-card-title class="card-header">
          <span class="headline">{{ $t("addModelAndVector") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :label="'Model Name'"
                  :items="DDGPTModel"
                  item-text="name"
                  item-value="id"
                  clearable
                  v-model="modelId"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :label="'Vector DB name'"
                  :items="DDVector"
                  item-text="name"
                  item-value="name"
                  clearable
                  v-model="vectorDBName"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-btn
                  class="primary white--text mt-3"
                  style="margin-left: 1em"
                  @click="Save()"
                  >{{ $t("add") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Clear()">{{
            $t("close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="EditdialogUser" persistent max-width="1000px">
      <v-card>
        <v-card-title class="card-header">
          <span class="headline">{{ $t("addModelAndVector") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :label="'Model Name'"
                  :items="DDGPTModel"
                  item-text="name"
                  item-value="id"
                  clearable
                  v-model="modelId"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :label="'Vector DB name'"
                  :items="DDVector"
                  item-text="name"
                  item-value="name"
                  clearable
                  v-model="vectorDBName"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-btn
                  class="primary white--text mt-3"
                  style="margin-left: 1em"
                  @click="Save()"
                  >{{ $t("add") }}</v-btn
                >
              </v-col>
            </v-row>
            <v-data-table
              :items-per-page="itemsPerPage2"
              :server-items-length="searchTotalTable2"
              :options.sync="options2"
              :items="dataTable2"
              :headers="headers2"
              :loading="loadingTable" 
              loading-text="Loading..."
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.number }}</td>
                  <td>{{ item.vectorDBName }}</td>
                  <td>
                    <v-btn icon @click="DeleteVectorDBNameMappinghGPTModel(true,item.vectorDBName)">
                      <img :src="images.delete" alt="Delete vector database mapping" />
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Clear()">{{
            $t("close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay  :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import call from "../api/call";
import checkPermissionTwo from "@/api/function.js";
const LogTrace = checkPermissionTwo;
export default {
  name: "ModelAndVectorManagement",
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    checkbox1: false,
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    loadingTable: false,
    tempID: 0,
    today: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    searchTotalTable2: 0,
    totalTable2: 0,
    itemsPerPage2: 10,
    loading: true,
    options: {},
    options2: {},
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDProvider: [
      "Azure",
      "Azure Postgresql",
      "Azure Internet",
      "Azure Internet",
      "Azure News",
    ],
    DDGPTModel: [],
    DDVector: [],
    headers: [],
    headers2: [],
    modelId: null,
    vectorDBName: null,
    searchModelId: null,
    isSearch: false,
    isFirst: true,
    isSearch2: false,
    isFirst2: true,
    dataTable: [],
    dataTable2: [],
    images: {
      edit: require("@/assets/edit1.png"),
      delete: require("@/assets/delete1.png"),
    },
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
    },
    options2: {
      handler() {
        this.GetByName();
      },
      deep: true,
    },
  },
  methods: {
    Refresh() {
      this.EditdialogUser = false;
    },
    Search() {
      this.dialog = true;
      this.isSearch = true;
      this.Get();
    },
    Get() {
      this.dialog = true;
      this.loading = true;
      const { page, itemsPerPage } = this.options;
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
      };
      call.GetVectorDBNameMappinghGPTModel(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.dialog = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetByName() {
      this.loadingTable = true;
      const { page, itemsPerPage } = this.options2;
      let temp = {
        page: this.isSearch2 ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable2 : itemsPerPage,
        id: this.searchModelId
      };
      call.GetVectorDBNameMappinghGPTModelById(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable2 = dataResponse.data.total;
            this.dataTable2 = dataResponse.data.data;
            this.totalTable2 = this.isFirst2
              ? dataResponse.data.total
              : this.totalTable2;
          } else {
            this.dataTable2 = [];
            this.searchTotalTable2 = 0;
            this.totalTable2 = 0;
          }
          this.loadingTable = false;
          this.isSearch2 = false;
          this.isFirst2 = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch2 = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      this.dialog = true;
      call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDGPTModel = dataResponse.data;
          } else {
            this.DDGPTModel = [];
          }
          this.dialog = false;
          this.GetDDVectorDBName();
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDVectorDBName() {
      this.dialog = true;
      call.GetDDVectorDBName(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDVector = dataResponse.data;
          } else {
            this.DDVector = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      if(!this.modelId || !this.vectorDBName){
        alert("Please Fill All The Fields!");
        return;
      }
      this.dialog = true;
      let request = {
        modelId : this.modelId,
        vectorDBName : this.vectorDBName
      };
      try {
          call.UpdateVectorDBNameMappinghGPTModel(
            request,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                alert(dataResponse.message);
                this.Adddialog = false;
                this.Clear();
                this.Get();
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              this.Adddialog = false;
              console.error(errorResource);
            }
          );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    DeleteVectorDBNameMappinghGPTModel(modelName, name) {
      if(!modelName){
        alert("There are no connected models.");
        return;
      }
      try {
        let deleteconfirm = confirm("Are you sure to delete this data?");
        if (deleteconfirm) {
          this.dialog = true;
          call.DeleteVectorDBNameMappinghGPTModel(
            name,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                alert(dataResponse.message);
                this.Clear();
                this.Get();
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              this.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else {
          this.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      this.Adddialog = true;
    },
    Edit(item) {
      this.vectorDBName = item.vectorDBName;
      this.modelId = item.gptModelID;
      if(item.gptModelID){
        this.EditdialogUser = true;
        this.searchModelId = item.gptModelID;
        if(!this.isFirst2){
          this.GetByName();
        }
      }
      else this.Add();

    },
    Clear() {
      this.EditdialogUser = false;
      this.Adddialog = false;

      this.searchModelId = null;
      this.dataTable2 = [];
      this.searchTotalTable2 = 0;
      this.totalTable2 = 0;

      this.modelId = null;
      this.vectorDBName = null;
    },
  },
  mounted() {
    this.GetDate();
    this.GetDDGPTModel();
    this.headers = [{
        text: this.$t("no"),align: 'center',sortable: false,},
      { text: 'Model name',align: 'center',sortable: false, },
      { text: 'Vector DB name',align: 'center',sortable: false, },
      { text: this.$t("edit"),align: 'center',sortable: false, },
      { text: this.$t("delete"),align: 'center',sortable: false, }
    ]
    this.headers2 = [{
        text: this.$t("no"),align: 'center',sortable: false,},
      { text: 'Vector DB name',align: 'center',sortable: false, },
      { text: this.$t("delete"),align: 'center',sortable: false, }
    ]
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}
textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
</style>
